module.exports = __webpack_public_path__ + "img/right.73717dd3.png";